// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"_12MlZ29eHA2omjiDwhs2m4","centerText":"_1kEfB-V-kFXegn8Js6lsuj","content":"_7elK_Y4r-oOsjCNCrs_CW","overflowVisible":"_1_z_yMKbJbCmFzjQuv0di2"};